<template>
  <div class="footer" style="height:233px;">
    <img v-if="appweb.footer" :src="appweb.footer" alt="" style="height:150px;">
    <div class="copy" >
      <p>{{appweb.copyright}}</p>
      <p style="padding-bottom:-1px;">
        <a href="http://www.beian.miit.gov.cn">{{appweb.recordno}}</a>
      </p>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["appweb"])
  }
};
</script>
<style>
/* 背景图特效 */
.bg-particles {
  background: #132743;
  height: 80px;
}

.footer {
  background: #132743;
  color: #fff;
  width: 100%;
  font-size: 12px;
}
.footer .copy {
   background: #132743;
  width: 100%;
  /* height: 80px; */
  border-top: 1px solid #3c4f68;
  padding: 10px 0 0 0;
  position: absolute;
}
.footer img {
  width: 100%;
}
.copy {
  text-align: center;
}
.copy a {
  color: #fff;
  font-size: 12px;
}
</style>




// WEBPACK FOOTER //
// src/components/xd-footer.vue